import type { GQL_ID } from '@@partner:types:graphql'
import type { OrderInfo } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import {
  ORDER_FIELDS,
  ORDER_PRODUCTS_FIELDS,
  ORDER_SHOP_FIELDS,
  ORDER_TOTALS_FIELDS
} from '@@partner:graphql/shortcuts'

export interface OrderQueryVariables {
  order_id: GQL_ID
}
export interface OrderQuery {
  order: OrderInfo
}

export const GQL_QUERY_ORDER = gql`
  query($order_id: ID!) {
    order(order_id: $order_id) {
      ${ORDER_FIELDS}
      ${ORDER_TOTALS_FIELDS}
      ${ORDER_SHOP_FIELDS}
      ${ORDER_PRODUCTS_FIELDS}
      assemblingSide
      shippingSide
      status
      customer_phone
      customerGeoPoint {
        latitude
        longitude
      }
      recipientInfo {
        firstName
        lastName
      }
      promocode {
        id
        code
      }
      deliverySlot {
        id
        slotTime
        slotDate
      }
      assignedCustomerId
      receipt_email
    }
  }
`

export const useFetchOrder = (order_id: GQL_ID) => {
  return useQuery<OrderQuery, OrderQueryVariables>(GQL_QUERY_ORDER, {
    variables: {
      order_id
    },
    fetchPolicy: 'network-only'
  })
}
